<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(clickAdd)">
        <div class="form-row">
          <div class="form-group col-md-6">
            <ValidationProvider
              tag="section"
              name="科系類別"
              v-slot="{ errors }"
              rules="required"
            >
              <el-select style="width:100%;" clearable v-model="majorSubjectCategory" placeholder="科系類別">
                <el-option
                  v-for="item in majorSubjectCategoryList"
                  :key="item.Guid"
                  :label="item.Name"
                  :value="item.Guid"
                >
                </el-option>
              </el-select>
              <span v-if="errors" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
          <div class="form-group col-md-6">
            <ValidationProvider
              tag="section"
              name="科系"
              v-slot="{ errors }"
              rules="required"
            >
              <el-select style="width:100%;" clearable v-model="majorSubject" placeholder="科系">
                <el-option
                  v-for="item in majorSubjectList"
                  :key="item.Guid"
                  :label="item.Name"
                  :value="item.Guid"
                >
                </el-option>
              </el-select>
              <span v-if="errors" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
            <input
              type="text"
              class="form-control"
              placeholder="科系描述"
              v-model.trim="ManpowerDemandSchoolDepartment.SchoolDepartmentDescription"
            />
          </div>
        </div>

        <div class="form-row">
          <button
            type="button"
            class="btn btn-secondary btn-sm"
            style="margin-left: 6px; margin-right: 10px"
            @click.prevent="clickCancel"
          >
            取消
          </button>
          <button type="submit" class="btn btn-primary btn-sm">儲存</button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
export default {
  name: "AddMajor",

  data() {
    return {
      type: "Education",

      // 科系類別
      majorSubjectCategoryList: [],
      // 科系選項
      majorSubjectList: [],

      majorSubjectCategory: "科系類別",
      majorSubject: "科系",

      // data
      ManpowerDemandSchoolDepartment: {
        SchoolDepartmentType: null,
        SchoolDepartmentGuid: null,
        SchoolDepartment: null,
        SchoolDepartmentDescription: null,
      },
    };
  },
  methods: {
    // 取得科系選項
    getMajorSubject(categoryGuid) {
      const vm = this;
      const api = `${window.endpoints.api}/BasicInformation/MajorSubject`;

      const params = {
        IsEnable: true,
        CategoryGuid: categoryGuid,
      };

      vm.$http.get(api, { params }).then((response) => {
        if (response.status === 200) {
          const arr = response.data.sort((a, b) => {
            return a.Seq - b.Seq;
          });
          vm.majorSubjectList = arr.map((item) => {
            return {
              Guid: item.Guid,
              Name: item.Name,
            };
          });
        }
      });
    },

    clickCancel() {
      this.$emit("addCancel");
    },

    clickAdd() {
      this.$emit("addMajor", this.ManpowerDemandSchoolDepartment, this.type);
    },
  },

  watch: {
    // 科系類別
    majorSubjectCategory: function (newVal) {
      if (newVal) {
        this.getMajorSubject(newVal);
        this.majorSubject = "科系";

        let newItem = this.majorSubjectCategoryList.find(item=>{
            return item.Guid===newVal
          }
        )
        this.ManpowerDemandSchoolDepartment.SchoolDepartmentType = newItem.Name;
        
      } else {
        this.majorSubject = null;
        this.majorSubjectList = [];
      }
    },

    // 科系
    majorSubject: function (newVal) {
      if (newVal && newVal!=="科系") {
        this.ManpowerDemandSchoolDepartment.SchoolDepartmentGuid = newVal;

        let newItem = this.majorSubjectList.find(item=>{
            return item.Guid===newVal
          }
        )
        this.ManpowerDemandSchoolDepartment.SchoolDepartment = newItem.Name;
        
      }
    },
  },

  created() {
    // 取得科系類別
    this.get_major_subject_category().then((result) => {
      this.majorSubjectCategoryList = result;
    });
  },
};
</script>

<style scoped lang="scss">
.btn-primary {
  &:disabled {
    background-color: #eee;
    border-color: #eee;
    color: black;
    cursor: auto;
  }
}
</style>
